<template>
<div class="wrapper">
  <div class="overlay" @click="closeWarningModal"></div>
  <div class="window">
    <div
      :class="{
        'window__header': true,
        'window__header_warning': warningData.style === 'warning'
      }"
    >
      <span class="window__header-title" v-if="warningData.style === 'warning'">Предупреждение</span>
      <span class="window__header-title" v-else >Ошибка</span>
      <div class="window__header-line"></div>
      <span
        :class="{
          'close': true,
          'close_warning': warningError
        }"
        @click="closeWarningModal"
      ></span>
    </div>
    <div class="window__inner inner">
      <h2 class="inner__title">
        {{ warningData.message }}
      </h2>
      <p class="inner__description">
        {{ warningData.description }}
      </p>
    </div>
    <div class="window__footer">
      <BaseBtnNew :name="'ОК'" @clickBtn="closeWarningModal">
        <approweIcon/>
      </BaseBtnNew>
    </div>
  </div>
</div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import approweIcon from '@/components/icons/approweIcon.vue'

export default {
  name: 'WindowError',
  components: {
    BaseBtnNew,
    approweIcon
  },

  setup () {
    const store = useStore()

    const warningData = computed(() => {
      return store.getters.getWarningData
    })

    const warningError = computed(() => {
      return store.getters.getWarningError
    })

    const closeWarningModal = () => {
      store.commit('SetWarningModal', false)
    }

    return {
      warningError,
      warningData,
      closeWarningModal
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  inset: 0;
  z-index: 100;
}

.overlay {
  position: fixed;
  inset: 0;
  background-color: #000;
  opacity: 0.7;
}

.window {
  z-index: 1;
  width: 53.021vw;
  background-color: #FFFFFF;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  border: 1px solid #C51B0E;

  &__header {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 1vw 0.729vw;
    font-size: 1vw;
    color: #FFFFFF;

    &-title {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      text-align: left;
      color: #C51B0E;
    }

    &-line {
      display: block;
      flex: 1;
      height: 2px;
      background-color: #C8C8C8;
    }
  }

  &__inner {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 1.042vw 1.667vw;
    gap: 1.042vw;
    border-top: none;
  }

  &__footer {
    padding: 24px;
    background-color: #C51B0E;
    display: flex;
    justify-content: center;
    :deep(.base-button) {
      width: 200px;
      background-color: #fff;
      color: #000;
    }
  }
}

.inner {
  font-size: 1.2vw;
  font-weight: 400;
  line-height: 1.146vw;
  color: #000000;

  &__title {
    font-weight: 600;
    align-self: flex-start;
  }
}
.close {
  position: relative;
  width: 12px;
  height: 2px;
  transform: rotate(45deg);
  background-color: #000000;
  transition: 0.8s;
  cursor: pointer;
  border-radius: 1px;

  &::after {
    content: '';
    position: absolute;
    right: 0px;
    width: 12px;
    height: 2px;
    transform: rotate(90deg);
    background-color: #000;
    border-radius: 1px;
  }
}

.window__header_warning {
  background-color: #F4DD02;
  color: #000000;
}

.close_warning {
  background-color: #000000;

  &::after {
    background-color: #000000;
  }
}

:deep(.base-button) {
  min-width: auto;
  padding: 1vw 1.2vw;
}
</style>
